import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {action, observable} from 'mobx'

import {t} from 'commons/i18n'
import Slider from 'react-rangeslider'

/**
 * @typedef {object} Props
 * @prop {number} duration
 * @prop {number} lastAccess
 * @prop {any=} children
 *
 * @augments {React.Component<Props>}
 */
@observer
export default class SessionTimeoutHandler extends Component {
  @observable accessor timeLeft

  constructor(props) {
    super(props)
    setInterval(this.updateTimeleft, 1000)
  }

  @action updateTimeleft = () => {
    if (window.app.lastAjax401 || this.timeLeft <= 0) {
      this.timeLeft = 0
      return
    }
    const updatedInBetween = window.app.timestampLastSuccessfulRequest
    const lastAccess = updatedInBetween ? updatedInBetween : this.props.lastAccess
    this.timeLeft = this.props.duration - (new Date().getTime() / 1000 - lastAccess / 1000)
  }

  renewSession = () => {
    app.refreshWithPing(true)
  }

  gotoLogin = () => {
    window.location.reload(true)
  }

  get isUrgent() {
    return this.timeLeft < 30 || this.timeLeft < (this.props.duration / 100) * 10
  }

  get isExpired() {
    return this.timeLeft <= 0
  }

  render() {
    if (isNaN(this.props.duration) || isNaN(this.timeLeft)) {
      return null
    }
    return (
        <div className={`SessionTimeoutHandler ${this.isUrgent ? 'is-urgent' : ''} ${this.isExpired ? 'is-expired' : ''}`}>
          <div className="SessionTimeoutHandler__duration-info">
            <span>{t('session.timeout.handler.auto.logout')}</span>
            <span>{Math.round(this.timeLeft / 60)} {t('MINUTES_SHORT')}</span>
          </div>
          <Slider min={0} max={this.props.duration} value={this.timeLeft} tooltip />
          <div className="SessionTimeoutHandler__action-info">
            {this.isUrgent && !this.isExpired && (
              <span>
                <i className="SessionTimeoutHandler__icon is-urgent fa fa-exclamation-triangle fa-4x" />
                {t('session.timeout.handler.will.expire')}
              </span>
            )}
            {!this.isExpired && (
              <button className="SessionTimeoutHandler__renew-button btn btn--light btn--dense" onClick={this.renewSession} type="button">
                {t('session.timeout.handler.renew')}
              </button>
            )}
            {this.isExpired && (
              <span>
                <i className="SessionTimeoutHandler__icon is-expired fa fa-exclamation-triangle fa-4x" />
                {t('session.timeout.handler.is.expired')}
                <button className="SessionTimeoutHandler__goto-login-button btn  btn--primary btn--dense" onClick={this.gotoLogin} type="button">
                  {t('session.timeout.handler.goto.login')}
                </button>
              </span>
            )}
          </div>
          {this.props.children && <div className="SessionTimeoutHandler__extras">{this.props.children}</div>}
        </div>
    )
  }
}